/* Bootleg Bath — product page behaviour.
   Reuses the catalogue and the icon/grouping rules already loaded by
   bb-scent-icons.js and bb-drawer.js; this file only adds what the page needs
   that the drawer doesn't: navigation between siblings, the slide-over panel,
   and its own add-to-bag. */
(function(){
  var root = document.querySelector('.pdp');
  if(!root) return;                                   /* not a product page */

  var CAT   = window.BB_CATALOGUE || [];
  var block = root.querySelector('[data-bb-scentblock]');
  var pickBox = root.querySelector('[data-bb-pdp-pick]');
  var picker  = root.querySelector('[data-bb-pdp-select]');
  var addBtn  = root.querySelector('[data-bb-pdp-add]');
  var qty     = document.getElementById('pdp-qty');
  var iconRow = root.querySelector('[data-bb-fragrance-icons]');
  var handle  = iconRow ? iconRow.dataset.handle : null;

  function byHandle(h){ return CAT.filter(function(p){ return p.handle===h; })[0]; }
  function groupKeyOf(p){ return (p && (p.group || p.type)) || ''; }
  function packOf(p){
    if(p && p.pack) return p.pack;
    var m = ((p && p.title) || '').match(/(\d+)\s*[- ]?\s*Pack/i);
    if(m) return m[1] + ' Pack';
    return 'Single';
  }
  function siblingsOf(p){
    var k = groupKeyOf(p); if(!k) return [p];
    var size = packOf(p);
    return [p].concat(CAT.filter(function(q){
      return q.handle!==p.handle && groupKeyOf(q)===k && packOf(q)===size; }));
  }

  var me   = handle ? byHandle(handle) : null;
  var sibs = me ? siblingsOf(me) : [];

  /* A one-of-a-kind product has nothing to distinguish — hide the whole block
     rather than repeat its own name under the price. */
  if(block && sibs.length < 2) block.hidden = true;

  /* Scent selector — same list as the icons, navigates on change. */
  if(picker && sibs.length > 1){
    pickBox.hidden = false;
    picker.innerHTML = sibs.map(function(p){
      return '<option value="'+p.url+'"'+(p.handle===handle?' selected':'')+'>'+
             (p.notes || p.title)+'</option>'; }).join('');
    picker.onchange = function(){
      if(!picker.value) return;
      /* Switch the image to the chosen scent straight away, so the selection
         registers instantly instead of waiting on the page load that follows. */
      var chosen = CAT.filter(function(q){ return q.url === picker.value; })[0];
      var hero = root.querySelector('.pdp__img');
      if(chosen && hero && chosen.images && chosen.images[0]) hero.src = chosen.images[0];
      window.location.href = picker.value;
    };
  }

  /* Quantity stepper */
  [].forEach.call(root.querySelectorAll('[data-qty]'), function(b){
    b.onclick = function(){
      qty.value = Math.max(1, (parseInt(qty.value,10)||1) + parseInt(b.dataset.qty,10)); };
  });

  /* Add to bag */
  if(addBtn && !addBtn.disabled){
    addBtn.onclick = function(){
      var id = addBtn.dataset.variant;
      var q  = Math.max(1, parseInt(qty.value,10)||1);
      var label = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      var root_url = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
      fetch(root_url+'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({items:[{id:Number(id), quantity:q}]})
      }).then(function(r){ return r.json(); })
        .then(function(){
          addBtn.classList.add('is-done'); addBtn.textContent = 'Added ✓';
          return fetch(root_url+'cart.js').then(function(r){ return r.json(); });
        }).then(function(c){
          document.querySelectorAll('.cart-count-bubble span[aria-hidden]')
            .forEach(function(e){ e.textContent = c.item_count; });
          var b = document.querySelector('.cart-count-bubble'); if(b) b.hidden = false;
          document.dispatchEvent(new CustomEvent('bb:cart:updated',{detail:c}));
          setTimeout(function(){
            addBtn.classList.remove('is-done'); addBtn.textContent = label;
            addBtn.disabled = false; }, 1700);
        }).catch(function(){
          addBtn.textContent = 'Try again'; addBtn.disabled = false; });
    };
  }

  /* ---- slide-over panel for Product Details / Ingredients ---- */
  var panel = document.getElementById('pdp-panel');
  if(!panel) return;
  var lastFocus = null;

  function openPanel(which){
    lastFocus = document.activeElement;
    /* Both sections are in the panel; scroll the requested one into view so a
       single panel serves both rows, as in the reference. */
    panel.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ panel.classList.add('is-open'); });
    var target = panel.querySelector('[data-panel="'+which+'"]');
    if(target) target.scrollIntoView({block:'start'});
    var close = panel.querySelector('.pdp__panel-close');
    setTimeout(function(){ if(close) close.focus(); }, 60);
  }
  function closePanel(){
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function(){ panel.hidden = true; }, 320);
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  [].forEach.call(root.querySelectorAll('[data-bb-panel]'), function(b){
    b.onclick = function(){ openPanel(b.dataset.bbPanel); };
  });
  [].forEach.call(panel.querySelectorAll('[data-bb-panel-close]'), function(e){
    e.onclick = closePanel;
  });
  document.addEventListener('keydown', function(e){
    if(panel.hidden) return;
    if(e.key === 'Escape') closePanel();
    if(e.key === 'Tab'){
      var f = panel.querySelectorAll('button,a[href]');
      if(!f.length) return;
      var first = f[0], last = f[f.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });
})();
